import { IconButton, AppBar, Toolbar, Table, TableHead, TableBody, TableRow, TableCell, Checkbox, Button, Tabs, Tab, Tooltip, Switch } from "@material-ui/core";
import * as React from "react";
import { Theme } from "@material-ui/core/styles";
import { observable, action, toJS } from "mobx";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import { config } from "src/config";
import { observer } from "mobx-react";
import { history } from "src/history.js";
import { SignUpEmailTemplate, settingsStore } from '.';
import { AdminToolBar } from '../../components';
import InfoIcon from '@material-ui/icons/Info';

interface IAppSetting {
    app_setting_id: number;
    SettingName: string;
    SettingCategory: string;
    SettingType: string;
    SettingDisplayName: string;
    SettingLastUpdate: string;
    SettingDescription: string;
    SettingValue: string;
    dev_only: number;
}

const styles = createStyles({
    root: {
        width: "100%",
        height: "100%",
        margin: "0 auto",
        // padding: "1.5rem",
        display: "flex",
        flexDirection: "column",
    },
    rowContainer: {
        width: "100%",
        display: "flex",
        alignContent: "center",
        margin: "0 auto",
        // padding: "3rem",
    },
    columnContainer: {
        width: "100%",
        display: "flex",
        margin: "0 auto",
        // padding: "3rem",
    },

    subheaderRow: {
        backgroundColor: '#cddadb',
    }
});

const PurpleSwitch = withStyles({
    switchBase: {
        // color: 'green',
        '&$checked': {
            color: '#3D9970',
        },
        '&$bar': {
            color: '#7FDBFF',
        },
    },
    checked: {},
})(Switch);


@observer
class CompanySettings extends React.Component<any> {

    constructor(props: any) {
        super(props);
    }

    public handleSubmit = () => {
        return settingsStore.saveSettings();
    }

    public handleChange = (row: IAppSetting, e: any) => {
        settingsStore.updateSetting(row.app_setting_id, e)
    }

    public getEditContent = (row: IAppSetting) => {

        const rowType = row.SettingType;
        switch (rowType) {
            case ('boolean'): {
                return (
                    <PurpleSwitch
                        checked={row.SettingValue}
                        // tslint:disable-next-line: jsx-no-lambda
                        onChange={(e: any) => this.handleChange(row, e.target.checked)}
                        // value='blah'
                        color="secondary"
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                    />
                )
            }
            default: {
                return (<div>edit</div>)
            }
        }
    }

    public getTableContent = () => {
        const { classes } = this.props;
        let current_category = '';
        return (
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Settings</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {settingsStore.AppSettings.map((setting: IAppSetting) => {
                        const table_rows = [];
                        if (setting.SettingCategory !== current_category) {
                            current_category = setting.SettingCategory;

                            table_rows.push(
                                <TableRow key={current_category} className={classes.subheaderRow}>
                                    <TableCell />
                                    <TableCell >{current_category.charAt(0).toUpperCase() + current_category.slice(1) + " Settings"}</TableCell>
                                    <TableCell />
                                </TableRow>
                            );
                        };

                        table_rows.push(
                            <TableRow key={setting.app_setting_id} >
                                <TableCell style={{ width: '20px' }}>
                                    <Tooltip title={setting.SettingDescription}>
                                        <InfoIcon />
                                    </Tooltip>
                                </TableCell>
                                <TableCell>
                                    {setting.SettingDisplayName}
                                </TableCell>
                                <TableCell>
                                    {this.getEditContent(setting)}
                                </TableCell>
                            </TableRow>
                        );

                        return table_rows;
                    })}
                    <TableRow>
                        <TableCell style={{ width: '20px', border: 'none' }} />
                        <TableCell style={{border: 'none' }} />
                        <TableCell style={{border: 'none' }}>
                            <Button
                                onClick={this.handleSubmit}
                                variant={'contained'}
                                disabled={!settingsStore.settings_save_valid}
                            >
                                Submit
                            </Button>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        )
    }

    public render() {
        const { classes } = this.props;

        if (!settingsStore.app_settings_loaded) {
            return <div>Loading</div>
        };

        return (
            <div className={classes.root}>
                {this.getTableContent()}
            </div>
        );
    }

}

export default withStyles(styles, { withTheme: true })(CompanySettings);


// WEBPACK FOOTER //
// ./src/modules/admin/modules/Settings/CompanySettings.tsx